import { useRef } from "react";
import { Typography, Tag } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import ProCard from "@ant-design/pro-card";
import { Tooltip } from "antd";

const { Title, Text } = Typography;

const CarouselSwiper = ({ heading, cards, variant = "default" }) => {
  const containerRef = useRef(null);

  const getCardStyles = () => {
    switch (variant) {
      case "tesla":
        return { border: "1px solid #d32f2f", backgroundColor: "#fff8f6" };
      case "competitors":
        return { border: "1px solid #1976d2", backgroundColor: "#f0f8ff" };
      case "sector":
        return { border: "1px solid #388e3c", backgroundColor: "#f9fff8" };
      default:
        return { border: "1px solid #ccc", backgroundColor: "#ffffff" };
    }
  };

  const scroll = (direction) => {
    if (!containerRef.current) return;
    const scrollAmount = 300;
    containerRef.current.scrollBy({
      left: direction === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth",
    });
  };

  return (
    <div
      style={{
        position: "relative",
        margin: "3rem 0",
        marginBottom: variant === "sector" ? "8rem" : "3rem", // 👈 Add extra space only for sector
      }}
    >
      <Title level={4} style={{ margin: "0 40px 1rem" }}>
        {heading}
      </Title>

      <LeftOutlined
        onClick={() => scroll("left")}
        style={{
          position: "absolute",
          left: 0,
          top: "55%",
          transform: "translateY(-50%)",
          fontSize: 20,
          zIndex: 2,
          cursor: "pointer",
        }}
      />
      <RightOutlined
        onClick={() => scroll("right")}
        style={{
          position: "absolute",
          right: 0,
          top: "55%",
          transform: "translateY(-50%)",
          fontSize: 20,
          zIndex: 2,
          cursor: "pointer",
        }}
      />

      <div
        ref={containerRef}
        style={{
          display: "flex",
          overflowX: "auto",
          scrollBehavior: "smooth",
          gap: 16,
          padding: "0 40px",
        }}
      >
        {cards.map((card, index) => (
          <ProCard
            key={index}
            style={{
              minWidth: 280,
              maxWidth: 320,
              flexShrink: 0,
              // ...getCardStyles(),
              cursor: "pointer",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)", // subtle shadow
            }}
            bordered
            onClick={() => card.url && window.open(card.url, "_blank")}
            bodyStyle={{ padding: 16 }}
          >
            <Tooltip title={card.title}>
              <Title
                level={5}
                style={{
                  marginBottom: 8,
                  fontSize: "medium",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {card.title}
              </Title>
            </Tooltip>

            {/* ✅ PREVIEW (if exists) */}
            {card.preview && (
              <Text
                style={{
                  display: "block",
                  marginBottom: 8,
                  color: "#555E6B", // ✨ slight bluish-gray for premium feel
                  fontSize: ".85rem", // slightly larger
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  display: "-webkit-box",
                }}
              >
                {card.preview}
              </Text>
            )}

            <Text type="secondary" style={{ fontSize: "small" }}>
              Last updated: {new Date(card.lastUpdated).toDateString()}
            </Text>
            {card.companies?.length > 0 && (
              <div style={{ marginTop: 12 }}>
                <Text strong style={{ display: "block", marginBottom: 4 }}>
                  Companies mentioned:
                </Text>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                  {card.companies.map((c) => (
                    <Tag key={c} color="blue">
                      {c}
                    </Tag>
                  ))}
                </div>
              </div>
            )}
            {card.tags?.length > 0 && (
              <div style={{ position: "relative", marginTop: 12 }}>
                <Text strong style={{ display: "block", marginBottom: 4 }}>
                  Tags:
                </Text>

                <div
                  style={{
                    position: "relative",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      display: "inline-flex",
                      gap: 8,
                      overflow: "hidden",
                      paddingRight: 20, // leave space for fade
                      maxWidth: "100%",
                    }}
                  >
                    {card.tags.map((tag) => (
                      <Tag
                        key={tag}
                        color="geekblue"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        {tag}
                      </Tag>
                    ))}
                  </div>

                  {/* Fade effect on right side */}
                  <div
                    style={{
                      position: "absolute",
                      right: 0,
                      top: 0,
                      height: "100%",
                      width: 40,
                      background:
                        "linear-gradient(to left, rgba(255,255,255,0.9), rgba(255,255,255,0))",
                      pointerEvents: "none",
                    }}
                  />
                </div>
              </div>
            )}
          </ProCard>
        ))}
      </div>
    </div>
  );
};

export default CarouselSwiper;
